export const ActiveChatByUser = 'ActiveChatByUser';
